import styled from "styled-components";

export const HomePageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 0px 48px;
    margin-bottom: 48px;
`